import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import uploadIcon from '../../../assets/img/uploadIcon.svg.js';
import uploadIconHover from '../../../assets/img/uploadIconHover.svg.js';

var _templateObject;
var UploadButtonStyled = styled.label(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  background-image: url(", ");\n  background-repeat: no-repeat;\n  height: 50px;\n  width: 125px;\n  margin: 10px 0;\n  border: none;\n  background-color: white;\n  &:focus {\n    border: none;\n    outline: none;\n  }\n  input[type=\"file\"] {\n    display: none;\n  }\n  &:hover {\n    background-image: url(", ");\n    cursor: pointer;\n  }\n"])), uploadIcon, uploadIconHover);
var UploadButton = function UploadButton(_ref) {
  var name = _ref.name,
    onChange = _ref.onChange,
    className = _ref.className;
  return /*#__PURE__*/React__default.createElement(UploadButtonStyled, {
    className: className
  }, /*#__PURE__*/React__default.createElement("input", {
    type: "file",
    name: name,
    onChange: onChange
  }));
};
UploadButton.propTypes = {
  name: PropTypes.string,
  onChange: PropTypes.func,
  className: PropTypes.any
};

export { UploadButtonStyled, UploadButton as default };
